import { siteChromeNavigationStoreKey } from "./constants";
import { updateNavigationTree } from "@src/template/state/modules/navigation";
import { getOrSetInLocalStorageWithExpiryAsync } from "@src/helpers/webStorage";
import { loadLoyaltyStatus } from "../loyalty";
import { getIsAuthenticated } from "./getIsAuthenticated";
import { authRuleFactory } from "./authRuleFactory";
import { premierRuleFactory } from "./premierRuleFactory";
import { loyaltyConsentRuleFactory } from "./loyaltyConsentRuleFactory";
import { loyaltyTierRuleFactory } from "./loyaltyTierRuleFactory";
import { loyaltyBenefitRuleFactory } from "./loyaltyBenefitRuleFactory";
import { segmentRuleFactory } from "./segmentRuleFactory";
import { filterTree } from "./filterTree";
import { getIsPremier } from "./getIsPremier";
import { getCustomerSegments } from "./getCustomerSegments";
import { getLoyaltyDetails } from "./getLoyaltyDetails";
import { getVariantKey } from "./getVariantKey";
import { createFetchClientNavigationWrapper } from "./createFetchClientNavigationWrapper";
import { SET_IS_AVAILABLE } from "@template/state/modules/loyalty/constants";

const getCountryData = store => {
  const {
    regionalStore: {
      countryCode,
      defaultLanguage,
      storeUrls,
      keyStoreDataversion
    },
    layout: { platform }
  } = store.getState();

  return [
    defaultLanguage,
    countryCode,
    storeUrls.default,
    platform,
    keyStoreDataversion
  ];
};

export const reloadNavigation = async store => {
  const variantKey = await getVariantKey();
  const [language, countryCode, storeUrl, platform, ksdvFromRegionalStore] =
    getCountryData(store);

  const fetchClientNavigationWrapper = createFetchClientNavigationWrapper(
    storeUrl,
    platform,
    variantKey
  );

  const navData = await getOrSetInLocalStorageWithExpiryAsync(
    {
      cacheKeyPrefix: siteChromeNavigationStoreKey,
      returnCachedOnDelegateFailure: true,
      removeOtherCacheItems: true,
      localStorageValueDelegate: fetchClientNavigationWrapper
    },
    countryCode,
    ksdvFromRegionalStore,
    language
  );

  const { dispatch, getState } = store;

  const isAuthenticated = await getIsAuthenticated();
  const isPremier = await getIsPremier(isAuthenticated);
  const customerSegments = await getCustomerSegments(isAuthenticated);
  const { consentStatus, customerTierId, isLoyaltyAvailable, loyaltySdk } =
    await getLoyaltyDetails(isAuthenticated);

  dispatch({
    type: SET_IS_AVAILABLE,
    payload: { isAvailable: isLoyaltyAvailable }
  });

  const rules = [
    authRuleFactory(isAuthenticated),
    premierRuleFactory(isPremier),
    loyaltyConsentRuleFactory(consentStatus),
    loyaltyTierRuleFactory(consentStatus, customerTierId),
    loyaltyBenefitRuleFactory(customerTierId, loyaltySdk),
    segmentRuleFactory(customerSegments)
  ];

  navData.tree = await filterTree(navData.tree, rules);

  await loadLoyaltyStatus({
    dispatch,
    getState,
    customerTierId,
    isLoyaltyAvailable
  });

  dispatch(updateNavigationTree(navData));
};
